import { useParams } from "react-router-dom";
import EditPrevisionForm from "../../../../components/EditPrevision";

function EditPrevisionsPage() {
  return (
    <section className="flex items-center justify-center">
      <EditPrevisionForm />
    </section>
  );
}
export default EditPrevisionsPage;
